import styles from "./styles.module.css";
import { useState } from "react";
import Modal from "../../../modal";
import { MdAdd, MdClose } from "react-icons/md";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";
import { makeid } from "../../../utils/pageactions";

export default function AddHook() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const { appId } = useParams();

  const handleSave = () => {
    db.collection("apps")
      .doc(appId)
      .collection("webhooks")
      .doc(makeid(24))
      .set({
        name,
        actions: [],
        schema: { type: name, name: name, list: false, fields: {} },
      })
      .then(() => {
        setName("");
        setOpen(false);
      });
  };
  return (
    <div onClick={() => setOpen(true)} className={styles.add}>
      <div>ADD WEBHOOK</div>
      <Modal onClose={() => setOpen(false)} open={open}>
        <div className={styles.form}>
          <div className={styles.formTitle}>
            ADD WEBHOOK
            <MdClose onClick={() => setOpen(false)} className={styles.close} />
          </div>
          <div className={styles.formContainer}>
            <div className={styles.formInputTitle}>Webhook Name</div>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="name..."
              className="input"
            />
          </div>
          <div className={styles.formContainer}>
            <button disabled={name.length === 0} onClick={handleSave}>
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
